import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { PRESETS_PERIODO, type MesPeriodo, type Periodo, type SeleccionPeriodo } from '@/lib/periodo-reporte'
import { formatDate } from '@/lib/utils'

interface PeriodoSelectorProps {
  seleccion: SeleccionPeriodo
  onChange: (seleccion: SeleccionPeriodo) => void
  periodo: Periodo
  /** Meses cerrados que se pueden elegir, del más reciente al más viejo. */
  meses: { value: MesPeriodo; label: string }[]
}

/** Filtro global de período del dashboard: presets y meses cerrados, con el rango de fechas que resulta. */
export function PeriodoSelector({ seleccion, onChange, periodo, meses }: PeriodoSelectorProps) {
  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <span className="text-sm text-muted-foreground">
        Del {formatDate(periodo.desde)} al {formatDate(periodo.hasta)}
      </span>
      <Select value={seleccion} onValueChange={(v) => onChange(v as SeleccionPeriodo)}>
        <SelectTrigger className="w-48" aria-label="Período">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="max-h-80">
          {PRESETS_PERIODO.map((p) => (
            <SelectItem key={p.value} value={p.value}>
              {p.label}
            </SelectItem>
          ))}
          {meses.length > 0 && (
            <>
              <SelectSeparator />
              <SelectGroup>
                <SelectLabel>Por mes</SelectLabel>
                {meses.map((m) => (
                  <SelectItem key={m.value} value={m.value}>
                    {m.label}
                  </SelectItem>
                ))}
              </SelectGroup>
            </>
          )}
        </SelectContent>
      </Select>
    </div>
  )
}
